import {
  INFERENCE_LOADING,
  FETCH_INFERENCE_SUCCESS,
  CREATE_INFERENCE,
  UPDATE_INFERENCE,
  DELETE_INFERENCE,
  OPEN_INFERENCE,
  FETCH_AI_MODELS_SUCCESS,
  SET_EXECUTION_TYPE
} from "../actions/inferenceActions";

const initialState = {
  loadingInference: true,
  inferences: [],
  page: 0,
  perPage: 20,
  totalPages: 1,
  selectedInference: {},
  alModels: []
};

export default (state = initialState, action) => {
  switch (action.type) {
    case INFERENCE_LOADING:
      return {
        ...state,
        loadingInference: action.payload
      };

    case FETCH_INFERENCE_SUCCESS: {
      const inferences =
        action && action.payload && action.payload.data
          ? action.payload.data
          : [];

      const page =
        action && action.payload && action.payload.page
          ? action.payload.page
          : initialState.page;
      const perPage =
        action && action.payload && action.payload.per_page
          ? action.payload.per_page
          : initialState.perPage;
      const totalPages =
        action && action.payload && action.payload.total
          ? Math.ceil(action.payload.total / perPage)
          : initialState.totalPages;

      return {
        ...state,
        inferences,
        page,
        perPage,
        totalPages,
        loadingInference: false
      };
    }

    case CREATE_INFERENCE:
      return {
        ...state,
        inferences: [...state.inferences, action.payload]
      };

    case UPDATE_INFERENCE:
      const filteredData = state.inferences.filter(
        inference => inference._id !== action.payload._id
      );
      return {
        ...state,
        inferences: [...filteredData, action.payload]
      };

    case DELETE_INFERENCE:
      return {
        ...state,
        inferences: state.inferences.filter(
          inference => inference._id !== action.payload
        )
      };

    case OPEN_INFERENCE:
      return {
        ...state,
        selectedInference: action.payload
      };

    case FETCH_AI_MODELS_SUCCESS:
      return {
        ...state,
        alModels: action.payload
      };

    case SET_EXECUTION_TYPE:
      const alModels = state.alModels.map(alModels => {
        if (alModels._id === action.payload._id) {
          return action.payload;
        }
        return alModels;
      });

      return {
        ...state,
        alModels
      };
    default:
      return state;
  }
};
